import { type PlatformApi } from '@app/external/common/controller/platform-api';

export const isEditorOrPreview = (platformApi: PlatformApi) => {
  const viewMode = platformApi.window.viewMode;
  return viewMode === 'Editor' || viewMode === 'Preview';
};
